import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
//导入router
import router from './router'
// 引入全局样式
import './assets/css/global.css'
// 引入字体图标
import 'font-awesome/css/font-awesome.min.css'
//导入axios
import axios from 'axios';


// axios.defaults.baseURL = 'http://192.168.1.22/P1_SystemAPI'      /systemapi
axios.defaults.baseURL = 'https://systemapi.61msh.com'
// axios.defaults.baseURL = 'https://192.168.1.22:443'
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
	router, //挂载
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js